// extracted by mini-css-extract-plugin
module.exports = {"button":"WiggleButton_button__kpLvW","Wiggle":"WiggleButton_Wiggle__3ZRLZ","shake":"WiggleButton_shake__L0Jat"};